export interface AdminAd {
  adId: number;
  name: string | null;
  thumbnailUrl: string | null;
  adType: string | null;
  adState: string | null;
  prompt: string | null;
  creatorEmail: string | null;
  creatorName: string | null;
  orgName: string | null;
  createDateTime: string | null;
}

/** Mirrors apiserver spec.ad.AdState. */
export const AD_STATES = [
  'SUBMITTED',
  'AWAITING_MEDIA',
  'IN_PROGESS',
  'PENDING_REVIEW',
  'CREATED',
  'FAILED',
  'MODERATION_FAILED',
  'DELETING'
];

export const AD_TYPES = ['GENERATE_WITH_AI', 'UPLOAD_MEDIA'];

export function adStateTone(state: string | null): 'green' | 'amber' | 'red' | 'gray' | 'blue' {
  switch (state) {
    case 'CREATED':
      return 'green';
    case 'PENDING_REVIEW':
      return 'amber';
    case 'FAILED':
    case 'MODERATION_FAILED':
      return 'red';
    case 'SUBMITTED':
    case 'IN_PROGESS':
    case 'AWAITING_MEDIA':
      return 'blue';
    default:
      return 'gray';
  }
}
